import React from "react";
import FixedAssetsMovingsGenericSkeleton from "./FixedAssetsMovingsGenericSkeleton";

function FixedAssetsMovingsDetailSkeleton() {
  return (
    <>
      <FixedAssetsMovingsGenericSkeleton />
    </>
  );
}

export default FixedAssetsMovingsDetailSkeleton;
